import ColorPickerModalRedux from './ColorPalettePickerRedux';

export default ColorPickerModalRedux;